import { render, staticRenderFns } from "./StockDetail.vue?vue&type=template&id=342cb594&scoped=true&"
import script from "./StockDetail.vue?vue&type=script&lang=js&"
export * from "./StockDetail.vue?vue&type=script&lang=js&"
import style0 from "./StockDetail.vue?vue&type=style&index=0&id=342cb594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342cb594",
  null
  
)

export default component.exports